import React from 'react';
import { OrderSide } from './BaseCalculatedOrders';
import styles from './OrderManagement.module.css';
import { Button, Modal } from '@/components/ui';

interface SubmitOrdersModalProps {
    side: OrderSide;
    titlePrefix: string;
    emailRecipients: string;
    onEmailChange: (value: string) => void;
    onCancel: () => void;
    onConfirm: () => void;
}

const SubmitOrdersModal: React.FC<SubmitOrdersModalProps> = ({
    side,
    titlePrefix,
    emailRecipients,
    onEmailChange,
    onCancel,
    onConfirm,
}) => {
    const label = side === 'buy' ? 'Buy' : 'Sell';
    const prefixStr = titlePrefix ? `${titlePrefix} ` : '';

    return (
        // Closes on a click outside the dialog only — no Escape and no ×, as before.
        <Modal
            open
            title={`Submit ${prefixStr}${label} Orders`}
            onClose={onCancel}
            closeOnEscape={false}
            showClose={false}
            maxWidth={440}
            footer={
                <>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button variant="primary" onClick={onConfirm}>Submit Orders</Button>
                </>
            }
        >
            <p className={styles['modal-desc']}>You are about to submit all calculated {prefixStr}{side} orders.</p>
            <div className={styles['modal-field']}>
                <label>Email Recipients (optional)</label>
                <input
                    className={styles['modal-input']}
                    type="text"
                    value={emailRecipients}
                    onChange={e => onEmailChange(e.target.value)}
                    placeholder="email1@example.com, email2@example.com"
                />
                <div className={styles['modal-hint']}>Separate multiple emails with commas.</div>
            </div>
        </Modal>
    );
};

export default SubmitOrdersModal;